<div class="card user-management-shell" *ngIf="availableTabs$ | async as availableTabs">
	<div class="card-body">
		<app-shell-admin-warning-banner></app-shell-admin-warning-banner>

		<al-tabs [tabInfo]="availableTabs" [selectedTab$]="selectedTabId$" [onTabClick]="onTabClick"></al-tabs>

		<div class="tabs-container user-management-shell__content">
			<router-outlet></router-outlet>
		</div>
	</div>
</div>
